import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalService } from '../../../service/local.service';
import { WhitelistConfigComponent } from '../../popups/whitelist-config/whitelist-config.component';

@Component({
  selector: 'app-whitelist-access',
  templateUrl: './whitelist-access.component.html',
  styleUrls: ['./whitelist-access.component.scss']
})
export class WhitelistAccessComponent implements OnInit {
  id = ''; ctryCode = '';
  constructor(public localService: LocalService, private modalService: NgbModal, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.params.subscribe(routeParams => {
      this.id = routeParams.reqId;
      this.ctryCode = routeParams.reqCtryCode;
    });
  }

  onOpenWhitelist() {
    const modalRef = this.modalService.open(WhitelistConfigComponent, { backdrop: 'static' });
    modalRef.componentInstance.id = this.id;
    modalRef.componentInstance.ctryCode = this.ctryCode;
    modalRef.componentInstance.isPopup = false;
  }

}
